import { put, takeLatest } from 'redux-saga/effects';
import { loadUI, applyLoadedUI } from './uiSlice';

function* loadUISaga() {
  try {
    // Load UI settings from localStorage or other sources
    if (typeof window !== 'undefined') {
      const savedUI = localStorage.getItem('uiSettings');
      if (savedUI) {
        const uiData = JSON.parse(savedUI);
        yield put(applyLoadedUI(uiData));
      }
    }
  } catch (error) {
    console.warn('Failed to load UI settings:', error);
  }
}

export default function* uiSaga() {
  yield takeLatest(loadUI.type, loadUISaga);
}